import { QueryHookOptions } from '@apollo/client';

import { useCommunityContext } from 'providers';
import {
  useGraduatedUsersListPerYearQuery,
  GraduatedUsersListPerYearQueryVariables,
  GraduatedUsersListPerYearQuery,
} from 'shared/graphql';

type Variables = Omit<
  GraduatedUsersListPerYearQueryVariables,
  'graduatingYearStart' | 'graduatingYearEnd' | 'community'
> & {
  graduatingYear: string;
};

type Options = QueryHookOptions<GraduatedUsersListPerYearQuery, Variables> & {
  variables: Variables;
};

export function useGraduatedUsersListPerYear(options: Options) {
  const { selectedCommunity } = useCommunityContext();

  const { data: response, loading } = useGraduatedUsersListPerYearQuery({
    skip: !selectedCommunity || options.skip,

    variables: {
      graduatingYearStart: `${options.variables.graduatingYear}-01-01`,
      graduatingYearEnd: `${options.variables.graduatingYear}-12-31`,
      community: selectedCommunity?.id as string,
    },
  });

  const activeUsers = response?.activeUsers?.items ?? [];
  const activeUsersCount = response?.activeUsers?.count ?? 0;

  const invitedUsers = response?.invitedUsers?.items ?? [];
  const invitedUsersCount = response?.invitedUsers?.count ?? 0;

  return {
    activeUsers,
    activeUsersCount,
    invitedUsers,
    invitedUsersCount,
    loading,
  };
}
